import Box from "component/layoutComponents/Box/Box";
import { IThemeProps } from "component/theme";
import styled from "styled-components";


export const StyledRatingSection = styled(Box)`
    ${({theme}: IThemeProps) => `
        display: flex;
        align-items: center;    
        svg {
            margin-right: ${theme.uptimeSpace[5]}px;
            width: ${theme.uptimeSpace[12]}px;
            height: ${theme.uptimeSpace[12]}px;
        }
        .MuiRating-root {
            color: ${theme.uptimeColors.newsKnowledgeColors.rating};
            width: auto;
        }
        .MuiRating-icon {
            font-size: ${theme.uptimeFontSizes.desktop.fz7}px;
        }
        .MuiGrid-item {
            display: flex;
        }
        #hideMe {
            -webkit-animation: cssAnimation 5s forwards;
            animation: cssAnimation 5s forwards;
            font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
            line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
            text-align: right;
            color: ${theme.uptimeColors.textColors.primary};
            margin-left: ${theme.uptimeSpace[5]}px;
        }
        @keyframes cssAnimation{
            0%   {opacity: 1;}
            90%  {opacity: 1;}
            100% {opacity: 0;}
        }
        @-webkit-keyframes cssAnimation{
            0%   {opacity: 1;}
            90%  {opacity: 1;}
            100% {opacity: 0;}
        }
    `}
`;